import React, { useState } from "react";
import { Fade, Form, Modal } from "react-bootstrap";
import CustomButton from "../CustomButton/CustomButton";
import Label from "../Label/Label";
import "./CareerApplyModal.scss";

const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const CareerApplyModal = ({
  showModal,
  positionName,
  onHide,
  onSubmit,
  isSubmitting,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [resumeFile, setResumeFile] = useState(null);

  const resetForm = () => {
    setName("");
    setEmail("");
    setPhoneNumber("");
    setResumeFile(null);
  };

  const handleClose = () => {
    resetForm();
    onHide?.();
  };

  const handleSubmit = async () => {
    if (!name.trim() || !email.trim() || !phoneNumber.trim()) {
      window.alert("Please fill in name, email, and phone number.");
      return;
    }

    let resumeUrl;

    if (resumeFile) {
      resumeUrl = await readFileAsDataUrl(resumeFile);
    }

    await onSubmit?.({
      name: name.trim(),
      email: email.trim(),
      phoneNumber: phoneNumber.trim(),
      resumeUrl,
    });

    resetForm();
  };

  return (
    <Modal
      className="CareerApplyModal"
      show={showModal}
      animation={Fade}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Label title={`Apply for ${positionName || "Position"}`} />
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Enter your name"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="Enter your email"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            value={phoneNumber}
            onChange={(event) => setPhoneNumber(event.target.value)}
            placeholder="Enter your phone number"
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Resume</Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(event) =>
              setResumeFile(event.target.files?.[0] || null)
            }
          />
        </Form.Group>
      </Modal.Body>
      <div className="modal-footer">
        <CustomButton
          type="button"
          title={isSubmitting ? "Submitting..." : "Submit Application"}
          onClick={handleSubmit}
        />
      </div>
    </Modal>
  );
};

export default CareerApplyModal;
